// Vendors
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
// Constants
import { FINANCIAL_LIST_PROPS } from '../constants/contract.constants';
// Contexts
import { useContractContextConsumerHook } from '../contexts/contract.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Handlers
import { ContractHandlers } from '../handlers/contract.handlers';
// Types
import { ContractHookType } from './types/contract.hook.type';
import { FinancialDataType } from '../components/financial-data/types/financial-data.component.type';

const useContractContainerHook = (): ContractHookType => {
  const [financialData, setFinancialData] = useState<FinancialDataType[]>(FINANCIAL_LIST_PROPS);
  const { contractState } = useContractContextConsumerHook();
  const { flowApiData } = useLayoutContextConsumerHook();
  const { fetching: externalFetching, error } = useFetchErrorContextConsumerHook(),
    { formatMessage } = useIntl();

  const { handleSetupFinancialContractData, handleDownloadDocument, handleDownloadFromUrl } =
    ContractHandlers({
      flowApiData,
      formatMessage,
      setFinancialData,
    });

  useEffect(() => {
    handleSetupFinancialContractData();
  }, []);

  return {
    error,
    externalFetching,
    contractState,
    financialData,
    formatMessage,
    handleDownloadDocument,
    handleDownloadFromUrl,
    accounts: flowApiData?.accounts,
  };
};

export { useContractContainerHook };
